import Vue from 'vue'
import App from './App.vue'
import router from './setup/router.js'

//Boostrap
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//css
import '@/css/main.min.css'


import globalMI from './mixins/globalMI.js';



var VueScrollTo = require('vue-scrollto');

Vue.use(BootstrapVue)
Vue.mixin(globalMI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})